<template>
    <DModal
        v-if="show"
        v-model:show="showModal"
        :title="__(translationKey + '.label')"
        :message="__(translationKey + '.description')"
        is-error
        is-confirm
        :confirm-button-text="'messages.save'"
        @confirm="emit('confirm')"
        @close="emit('close')"
    >
        <div class="retired-warning-list">
            <div v-if="linkedProducts.length">
                <strong>{{ __(translationKey + '.products_heading') }}</strong>
                <ul>
                    <li
                        v-for="product in linkedProducts"
                        :key="product.id"
                    >
                        {{ product.name }}
                    </li>
                </ul>
            </div>
        </div>
    </DModal>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    translationKey: {
        type: String,
        required: true
    },
    linkedProducts: {
        type: Array,
        default: () => { return [] }
    }
})

const emit = defineEmits(['confirm', 'close'])

const showModal = computed({
    get () {
        return props.show
    },
    set (value) {
        if (!value) {
            emit('close')
        }
    }
})
</script>

<style scoped>
.retired-warning-list {
    padding: 0 20px 15px;
    opacity: 0.6;
}
</style>
